import { AddToCart } from 'helpers/cart/AddToCart';
import { PriceLabel } from 'helpers/cart/PriceLabel';
import { CheckoutButton } from 'helpers/cart/AddToCart';
import { useSelector } from 'react-redux';

export const BuyBlock = (props) => {
    const auth = useSelector((store) => store.auth);
    const user = useSelector((store) => store.user);

    return (
        <div 
            className={ "marketplace-cta d-flex align-items-center" + (
                props?.from === 'strategy' ?
                    " flex-wrap justify-content-between justify-content-sm-start flex-sm-row-reverse w-xs-100 pr-0 pr-sm-3 mb-3 mb-md-0" :
                    " px-3"
            ) + (
                auth && props?.from === 'marketplace' && props?.item?.seller_name === user?.name ?
                    " justify-content-end" :
                    " justify-content-between"
            )}
        >
            {
                (props.checkout === true && auth && props.item?.seller_id !== user?.id && props.item.price > 0) ?
                    <CheckoutButton item={props.item} from={props.from} /> : null
            }
            {
                (props.item?.seller_id !== user?.id) ?
                    <AddToCart item={props.item} dti={props?.dti}></AddToCart> : null
            }
            <PriceLabel item={props.item} viewOneStrategy={props.viewOneStrategy} from={props.from} dti={props?.dti} />
        </div>
    )
}